export default __webpack_public_path__ + "static/media/skills-pana.a2ea79ce.png";